setTimeout(() => {
 if(BSS_B2B){
    const ele = document.querySelector('.ea-sticky-cart')
    if(ele){
        const observe = new MutationObserver((MutationList) => {
            for(let item of MutationList){
                if((item.target.className.includes('eascProdBox') && item.addedNodes?.length) || (item.target.id === 'ea-sticky-cart-root' && item?.addedNodes?.length)){
                    setTimeout(() => {
                        const items = BSS_B2B.shopData.cart.items;
                    const itemsEle = document.querySelectorAll('.eascProdBox .easc-productRow');
                    if(itemsEle){
                        itemsEle.forEach((item, index) => {
                            const key = items[index]?.key;
                            if(key){
                                const keyItem = item.querySelectorAll('.easc-prodRowPrice');
                                if(keyItem.length){
                                    keyItem.forEach(keyEle => {
                                        keyEle.setAttribute('bss-b2b-cart-item-key', key)
                                        keyEle.setAttribute('bss-b2b-item-original-price', '')
                                    })
                                }
                            }
                        })
                        document.querySelector(".easc-subtotalDiscIcon")?.setAttribute('bss-b2b-cart-total-price', true)
                        setTimeout(() => {BSS_B2B.observer.cartSubject.notifyObserver('CartMutate', 'CartPriceMutate');}, 1000)
                    }
                    }, 3000)
                }
            }
        })
        observe.observe(ele, {childList: true, childList: true, subtree: true})
    }
 }

 const isCart = window.location.pathname === '/cart';
 if(isCart) {
    document.querySelector(".eascMiniCartDiv")?.remove();
 }
}, 300)